import { TranslationRecord } from '../../../TranslationRecord';
import { enTranslations } from '../../../global-translations/en';

export const enMessages: TranslationRecord = {
  ...enTranslations,
};
